import React from 'react';
import { toast } from 'react-toastify';
import { connect } from 'react-redux';
import Ax from "../../components/hoc/Ax";
import HttpAPICall from '../../services/HttpAPICall';
import TapApiUrls, { IAM_API_BASE_URL_2 } from '../../services/TapApiUrls';
import AppBaseComponent from '../../components/AppBaseComponent';
import TapIcon from '../../services/TapIcon';
import Loader from '../../components/ui/Loader/Loader';
import { Modal } from "bootstrap";
import TapSelect from '../../components/ui/TapSelect';
import moment from 'moment';
import DatePicker from "react-datepicker";
import TapHelper from '../../services/TapHelper';


class ProjectSearchModal extends AppBaseComponent {
    constructor(props) {
        super(props);
        this.projectUrl             =   IAM_API_BASE_URL_2 + '/project';
        this.initialSearch = {
            search_by_name                  :   '',
            search_status                   :   '',
            search_site_ids                 :   [],
            search_project_id               :   '',
            search_project_start_date       :   "",
            search_project_end_date         :   "",
            search_category_ids             :   [],
            search_without_category         :   ""
        }

        this.searchFormLabel = {
            'search_by_name'                :   'Name: ',
            'search_status'                 :   'Status: ',
            'search_site_ids'               :   'Site: ',
            'search_project_id'             :   'Project ID: ',
            'search_category_ids'           :   'Categories: ',
            'search_without_category'       :   'Categories: '

        };

        this.state = {
            modalLoading                    :       false,
            searchFormData                  :       { ...this.initialSearch },
            submittedSearchFormData         :       { ...this.initialSearch },
            formSearchedElems               :       [],
            status                          :       [],
            siteList                        :       [],
            dateRange                       :       [null, null],
            modalLoading                    :       false,
            categories                      :   [],
            isMasterDataLoaded              : false,
            pendingAutoSearch               : false
        }

        this.searchModal = React.createRef();
    }

    componentDidMount() {
        this.modal = new Modal(document.getElementById('projectSearchModal'), { keyboard: false, backdrop: false });
        this.searchFormDataInit()
        const { search } = this.props.location;
        const searchParams = new URLSearchParams(search);
        const searchText = TapHelper.sanitizeObject(searchParams.get('searchText'));
        if (searchText) {
            this.setState(prevState => ({
                searchFormData: {
                    ...prevState.searchFormData,
                    search_by_name: searchText
                },
                 pendingAutoSearch: true  
            }), () => {
                this.handleSearch();
            });
        }
    }
    setSearchFromWidget = (filters) => {
        const { search } = this.props.location;
         const searchParams = new URLSearchParams(search);
        const searchText = TapHelper.sanitizeObject(searchParams.get('search_without_category'));
        this.setState(
            prevState => ({
                searchFormData: {
                    ...prevState.searchFormData,
                    ...filters,
                    search_without_category : searchText,
                },
                   pendingAutoSearch: true 
            }),
            () => {
                this.handleSearch();
            }
        );
    };

    componentDidUpdate(prevProps, prevState) {
        if (
            this.state.isMasterDataLoaded &&
            this.state.pendingAutoSearch &&
            !prevState.isMasterDataLoaded
        ) {
            this.setState(
                { pendingAutoSearch: false },
                () => this.handleSearch()
            );
        }
        if (this.props.location.search !== prevProps.location.search) {
            const { search } = this.props.location;
            const searchParams = new URLSearchParams(search);
            const searchText = TapHelper.sanitizeObject(searchParams.get('searchText'));
            if (searchText) {
                this.setState(prevState => ({
                    searchFormData: {
                        ...prevState.searchFormData,
                        search_by_name: searchText
                    }
                }), () => {
                    this.handleSearch();
                });
            }
        }
    }
    searchFormDataInit = () => {
        this.setState({ modalLoading: true });
        HttpAPICall.withAthorization('GET', this.projectUrl + '/form_data', this.props.access_token, null, null, (response) => {
            const respData      = response.data;
            this.setState({
                status: respData && respData.status.length > 0 ? respData.status.map(s => { return { label: s.status, value: s.key } }) : [],
                categories: respData && respData.categories.length > 0 ? respData.categories.map(s => { return { label: s.name, value: s.id } }) : [],
                isMasterDataLoaded: true
            })
        }).then(() => this.setState({ modalLoading: false }));
        const sites     = this.props.group_sites;
        this.setState({
            siteList: sites && sites.length > 0 ?
                sites.map(site => ({ label: site.site_name, value: site.id })) : [],
        });

    }
    showModal = () => {
        this.modal.show();
    }
    closeModal = () =>{
        this.modal.hide();
    }
    handleDateRangeChange = (dates) => {
        const [start, end] = dates;
        this.setState({
            dateRange: dates,
            searchFormData: {
                ...this.state.searchFormData,
                search_project_start_date: start,
                search_project_end_date: end
            }
        });
    }

    handleSearch = (e) => {
       e && e.preventDefault();
         if (!this.state.isMasterDataLoaded) return;
        const searchParams = {};
        const searchedElems = [];

        Object.keys(this.state.searchFormData).forEach(key => {
            const value = this.state.searchFormData[key];
            if (value && value.toString().length > 0) {
                searchParams[key] = value;
                if (this.searchFormLabel[key]) {
                    let displayValue = value;

                    if (key == 'search_status') {

                        const status = this.state.status.find(s => s.value == value);
                        displayValue = status ? status.label : value;
                    } 
                    if (key === 'search_site_ids') {
                        displayValue = value.map(siteId => {
                            const site = this.state.siteList.find(s => s.value === siteId);
                            return site ? site.label : '';
                        }).join(', '); 
                    }
                    if (key === 'search_category_ids') {
                        displayValue = this.state.categories.filter(c =>  value.includes(c.value)).map(s => s.label).join(', ') ;
                    }
                    if (key === 'search_without_category') {
                        displayValue = "Without Category";
                    }
                    
                   
                    searchedElems.push(this.searchFormLabel[key] + `<b>${displayValue}</b>`);
                }
                
            }
        }); 
        const [startDate, endDate] = this.state.dateRange;
        if (startDate || endDate) {
            const formattedStartDate = startDate ? moment(startDate).format('DD-MMM-YYYY') : 'N/A';
            const formattedEndDate = endDate ? moment(endDate).format('DD-MMM-YYYY') : 'N/A';
            const dateRangeDisplay = `Project Start Date : <b>${formattedStartDate}</b> - <b>${formattedEndDate}</b>`;
            searchedElems.push(dateRangeDisplay);
        }

        this.setState({
            submittedSearchFormData: { ...this.state.searchFormData },
            formSearchedElems: searchedElems
        }, () => {
            this.closeModal();
            this.props.onSearch(searchParams, searchedElems);
        });
    }
    
    
    clearSearch = () => {
        this.setState({
            searchFormData: { ...this.initialSearch },
            submittedSearchFormData: { ...this.initialSearch },
            formSearchedElems: [],
            dateRange: [null, null]
        });
    }

    render() {
        const [startDate, endDate] = this.state.dateRange;
        return (
            <div className="modal fade" id="projectSearchModal" tabIndex="-1" ref={this.searchModal}>
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Search Projects</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <form onSubmit={this.handleSearch}>
                            {
                                this.state.modalLoading
                                    ?
                                    <Loader />
                                    :
                                    <>
                                        <div className="modal-body">
                                            <div className='row'>
                                                <div className='col-sm-3 mb-2'>
                                                    <label className="col-form-label">Project ID</label>
                                                </div>
                                                <div className="col-sm-8 mb-2">
                                                    <input
                                                        name="search_project_id"
                                                        type="text"
                                                        className="form-control"
                                                        value={this.state.searchFormData.search_project_id}
                                                        onChange={(e) => this.formInputHandler(e, 'searchFormData')}
                                                        placeholder="Enter Project ID"
                                                        autoComplete="off"
                                                    />
                                                </div>

                                            </div>
                                            <div className='row'>
                                                <div className='col-sm-3 mb-2'>
                                                    <label className="col-form-label">Project Name</label>
                                                </div>
                                                <div className="col-sm-8 mb-2">
                                                    <input
                                                        name="search_by_name"
                                                        type="text"
                                                        className="form-control"
                                                        value={this.state.searchFormData.search_by_name}
                                                        onChange={(e) => this.formInputHandler(e, 'searchFormData')}
                                                        placeholder="Enter Project Name"
                                                        autoComplete="off"
                                                    />
                                                </div>
                                            </div>

                                            <div className='row'>
                                                <div className='col-sm-3 mb-2'>
                                                    <label className="col-form-label">Category</label>
                                                </div>
                                                <div className="col-sm-8 mb-2">
                                                    <TapSelect
                                                        changeEvent={(selectedOption) => {
                                                            this.tapSelectChange(selectedOption, 'searchFormData', 'search_category_ids');
                                                        }}
                                                        isSearchable={true}
                                                        isClearable={true}
                                                        isMulti={true}
                                                        placeholder="Select Category"
                                                        options={this.state.categories}
                                                        value={this.state.categories.filter(c => this.state.searchFormData.search_category_ids.includes(c.value))}
                                                    />
                                                </div>
                                            </div>

                                            <div className='row'>
                                                <div className='col-sm-3 mb-2'>
                                                    <label className="col-form-label">Status</label>
                                                </div>
                                                <div className="col-sm-8 mb-2">
                                                    <TapSelect
                                                        changeEvent={(selectedOption) => {
                                                            this.setState({
                                                                searchFormData : {...this.state.searchFormData, search_status : selectedOption ? selectedOption.value : ''}
                                                            })
                                                        }}
                                                        isSearchable={true}
                                                        isClearable={true}
                                                        placeholder="Select Status"
                                                        options={this.state.status}
                                                        value={this.state.status.find(s => s.value == this.state.searchFormData.search_status)}
                                                    />
                                                </div>
                                            </div>
                                            <div className='row'>
                                                <div className='col-sm-3 mb-2'>
                                                    <label className="col-form-label">Site</label>
                                                </div>
                                                <div className="col-sm-8 mb-2">
                                                    <TapSelect
                                                        changeEvent={(selectedOption) => {
                                                            this.tapSelectChange(selectedOption, 'searchFormData', 'search_site_ids');
                                                        }}
                                                        isSearchable={true}
                                                        isClearable={true}
                                                        isMulti={true}
                                                        placeholder="Select Site"
                                                        options={this.state.siteList}
                                                        value={this.state.siteList.filter(s =>
                                                            this.state.searchFormData.search_site_ids.includes(s.value)
                                                        )}
                                                    />
                                                </div>
                                            </div>
                                            <div className='row'>
                                                <div className='col-sm-3 mb-2'>
                                                    <label className="col-form-label">Project Start Date</label>
                                                </div>
                                                <div className="col-sm-8 mb-2">
                                                    <div className="add_calender_section pt-0">
                                                        <DatePicker
                                                            selectsRange
                                                            startDate={startDate}
                                                            endDate={endDate}
                                                            onChange={this.handleDateRangeChange}
                                                            dateFormat="dd-MMM-yyyy"
                                                            className="form-control"
                                                            placeholderText="Select date range"
                                                            //value={}
                                                            monthsShown={2}
                                                        />
                                                        <TapIcon.imageIcon icon={TapIcon.CalenderIcon} className="add_calender-icon" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                            }
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                <button type="submit" className="btn btn-primary">Search</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        access_token: state.auth.access_token,
        group_sites: state.app.group_sites && state.app.group_sites.length > 0 ? state.app.group_sites : [],
    };
};

export default connect(
  mapStateToProps,
  null,
  null,
  { forwardRef: true }
)(ProjectSearchModal);


